import { render, staticRenderFns } from "./PlayerDrive.vue?vue&type=template&id=54d3f04b"
import script from "./PlayerDrive.vue?vue&type=script&lang=js"
export * from "./PlayerDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports